

const firstLetterPicker = (name) => {
  let initial = (name.match(/[a-zA-Z]/) || []).pop();
  return initial.toUpperCase();
};
const firstTwoLetterPicker = (name) => {
  let initials = name?.match(/\b\w/g) || [];
  initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  return initials;
};




const HELPERS = {
  firstLetterPicker, firstTwoLetterPicker
};


export default {
  ...HELPERS
};